import React from 'react';
import { TableRow, IconButton, Avatar } from '@material-ui/core';
import { useSelector } from 'react-redux';
import getValue from '../helpers/getValue';
import TableCell from './TableCell';
import useStyles from '../useStyles';
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  ImageOutlined
} from '@material-ui/icons';

function Row(props) {
  const classes = useStyles();
  const { columns } = props;
  const { ixImage } = useSelector(state => state.auth);
  return (
    <TableRow
      className={`${props.showDetails ? classes.details : ''} ${
        classes.rowBgColor
      }`}
      onClick={props.onToggleDetails}
    >
      <TableCell padding="checkbox" align="center">
        <IconButton aria-label="expand row" onClick={props.onToggleDetails}>
          {props.showDetails ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </IconButton>
      </TableCell>
      <TableCell align="center" className={classes.profileCell}>
        <Avatar
          className={classes.avatar}
          variant="rounded"
          src={`/api/images/${ixImage}/prod/${props.ixProd}/active_prod_avatar.jpg`}
        >
          <ImageOutlined size="large" />
        </Avatar>
      </TableCell>

      {columns.map(column => (
        <TableCell
          key={column?.key ?? column.fld}
          style={{
            width: column.width,
            minWidth: column.width
          }}
          align={column?.align ?? 'left'}
        >
          {getValue(column, props)}
        </TableCell>
      ))}
    </TableRow>
  );
}

export default Row;
